import React, { useState, useEffect } from 'react';
import StatCard from '../../components/StatCard';
import { cloudAPI } from '../../utils/api';

export default function RevenuePage() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cloudAPI.getRevenue()
            .then(res => {
                // Backend: { pro_users, monthly_costs: [{month, infra_cost_usd, notes}] }
                const d = res.data || {};
                const monthly = Array.isArray(d.monthly) ? d.monthly
                              : Array.isArray(d.monthly_costs) ? d.monthly_costs
                              : Array.isArray(d.rows) ? d.rows
                              : [];
                const latest = monthly[0] || {};
                setData({
                    pro_users: Number(d.pro_users) || 0,
                    mrr: d.mrr != null ? d.mrr : 0,
                    infra_cost: d.infra_cost != null ? d.infra_cost : (latest.infra_cost_usd ?? 0),
                    monthly,
                });
            })
            .catch(err => console.error('Revenue error:', err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="text-gray-400">Loading...</div>;
    if (!data) return <div className="text-red-500">Failed to load</div>;

    return (
        <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Revenue</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <StatCard title="Pro Users" value={data.pro_users || 0} subtitle="Active subscriptions" />
                <StatCard title="MRR" value={`$${data.mrr || 0}`} subtitle="Monthly recurring revenue" />
                <StatCard title="Infra Cost" value={`$${data.infra_cost || 0}`} subtitle="This month" />
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Monthly Costs</h3>
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Month</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Infra Cost</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Revenue</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Notes</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {(data.monthly || []).map((row, idx) => (
                                <tr key={idx} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{row.month}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">${row.infra_cost_usd || 0}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">${row.revenue_usd || 0}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{row.notes || '-'}</td>
                                </tr>
                            ))}
                            {(!data.monthly || data.monthly.length === 0) && (
                                <tr><td colSpan="4" className="px-6 py-6 text-sm text-gray-400 text-center">No cost data yet</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
